import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { enterSupportContext, leaveSupportContext } from "../Redux/Actions/contextAction";

/** The customer organization a staff member is currently working in, if any. */
export function useSupportContext() {
  const dispatch = useDispatch();
  const activeOrg = useSelector((state) => state.Context.activeOrg);
  const enter = useCallback((org) => dispatch(enterSupportContext(org)), [dispatch]);
  const leave = useCallback(() => dispatch(leaveSupportContext()), [dispatch]);
  return { activeOrg, isActive: Boolean(activeOrg), enter, leave };
}

/**
 * The user id every data-scoped API call must use: the active customer org
 * when a staff member has entered one, otherwise the logged-in user. Replaces
 * `user._id` wherever that meant "whose data", never where it means "who am I".
 */
export function useContextUserId() {
  const user = useSelector((state) => state.User.user);
  const activeOrg = useSelector((state) => state.Context.activeOrg);
  return activeOrg?._id ?? user?._id;
}
